import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getCurrentPartnerSession } from '../utils/utils';

export const usePartnerAuth = () => {
  const navigate = useNavigate();
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);
  const [hasCheckedAuth, setHasCheckedAuth] = useState(false);

  useEffect(() => {
    let isMounted = true;
    (async () => {
      try {
        const session = await getCurrentPartnerSession();

        if (!isMounted) {
          return;
        }

        setHasCheckedAuth(true);

        if (!session || typeof session === 'string' || !session?.isUserValid) {
          if (isMounted) {
            setIsAuthenticated(false);
            navigate('/', { replace: true });
          }
          return;
        }

        if (isMounted) {
          setIsAuthenticated(true);
        }
      } catch (error) {
        if (isMounted) {
          setHasCheckedAuth(true);
          setIsAuthenticated(false);
          navigate('/', { replace: true });
        }
      }
    })();

    return () => {
      isMounted = false;
    };
  }, [navigate]);

  return { isAuthenticated, hasCheckedAuth };
};
